import { render, staticRenderFns } from "./InfinityChange.vue?vue&type=template&id=5c1809e4&scoped=true"
import script from "./InfinityChange.vue?vue&type=script&lang=ts"
export * from "./InfinityChange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1809e4",
  null
  
)

export default component.exports